import React from 'react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {LineupsMemberStatsViewModel} from "../../../../domain/yard/lineups/lineups-member/stats/lineups-member.stats.view-model";
import styles from "../../styles/competitor-players-stats-module.module.scss";
import classNames from "classnames";

export class CompetitorPlayersStatsModulePlayerStatsListItemProps extends BaseProps {
  item: LineupsMemberStatsViewModel;
}

export const CompetitorPlayersStatsModulePlayerStatsListItem = (props: CompetitorPlayersStatsModulePlayerStatsListItemProps) => {
  return (
    <div className={classNames(styles.player_stats_list_item_container)}>
      <div className={classNames(styles.player_stats_list_item_text)}>{props.item.name}</div>
      <div className={classNames(styles.player_stats_list_item_text)}>{props.item.value}</div>
   </div>
  )
}
